import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { IoMdArrowDropdown } from "react-icons/io";
import { Box, colors, Grow } from "@material-ui/core";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { BusinessSearchScreen } from "../../business-search/BusinessSearchScreen";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    height: "100%",
  },

  button: {
    height: "100%",
    color: theme.palette.common.white,
    border: "none",
    background: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: 14,
    textDecoration: "none",
    borderRadius: 4,
    padding: "0 16px",
    whiteSpace: "nowrap",

    "&:hover": {
      color: theme.palette.common.white,
      opacity: ".9",
    },

    "& .arrow": {
      display: "inline-block",
      marginLeft: 6,
    },
  },

  dropdown: {
    position: "absolute",
    top: 50,
    right: 0,
    zIndex: 1,
    width: 140,
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),

    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[2],
    transition: theme.transitions.create(["width"]),

    "& .dropdownItem": {
      display: "block",
      padding: "6px 14px 8px 14px",
      fontSize: 14,
      fontWeight: theme.typography.fontWeightLight,
      color: colors.grey[700],
      cursor: "pointer",
      textDecoration: "none",

      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",

      "& .icon": {
        display: "inline-block",
        marginRight: 12,
        fontSize: 16,
      },

      "&:hover": {
        backgroundColor: "#F5F5F5",
        textDecoration: "none",
      },

      "&.selected": {
        backgroundColor: "#F5F5F5",
      },

      "& span": {
        display: "inline-block",
      },
    },
  },
}));

export const CreateAction = (props: any) => {
  const classes = useStyles(props);
  // State
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className={classes.root}>
        <button type="button" className={classes.button} onClick={handleClick}>
          <FormattedMessage id="sharedScreen.create" />
          <span className="arrow">
            <IoMdArrowDropdown size={14} />
          </span>
        </button>
        <Grow in={open} disableStrictModeCompat={false}>
          <Box className={classes.dropdown} zIndex="modal">
            <Link
              to={`${BusinessSearchScreen.routeName}?option=bo`}
              className="dropdownItem"
            >
              <FormattedMessage id="sharedScreen.createNewBusiness" />
            </Link>
            <Link
              to={`${BusinessSearchScreen.routeName}`}
              className="dropdownItem"
            >
              <FormattedMessage id="sharedScreen.managedNewBranche" />
            </Link>
          </Box>
        </Grow>
      </div>
    </ClickAwayListener>
  );
};
